<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>用户</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="queryParams.name" placeholder="请输入名称" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="queryParams.code" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.mobile">
                <el-input v-model="queryParams.mobile" placeholder="请输入手机号" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <vDropdown
                    model_key="status"
                    model_name="请选择状态"
                    select_value="value"
                    request_uri="dropdownCommonStatus"
                    :model_value_default="queryParams['status']"
                    @onDropChange="onDropChange"
                    ref="status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.role_id">
                <vDropdown
                    model_key="role_id"
                    model_name="请选择角色"
                    request_uri="dropdownRoles"
                    :model_value_default="queryParams['role_id']"
                    @onDropChange="onDropChange"
                    ref="role_id_ref"
                    display_name="role_name"
                    select_value="id"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="admin" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="admin"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['code', 'name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="绑定角色" placement="top-start">
                            <i class="el-icon-user-solid" @click="handleRole(scope.$index, scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置密码" placement="top-start">
                            <i class="el-icon-refresh" @click="resetPassword(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>

        <!-- 绑定角色 -->
        <el-dialog
            :close-on-click-modal="false"
            v-dialogDrag
            title="绑定角色"
            :visible.sync="roleData.visable"
            width="600px"
            :before-close="handleRoleClose"
        >
            <el-table
                :data="roleData.data"
                element-loading-text="数据拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
                @selection-change="handleRoleChange"
                ref="role_data_ref"
            >
                <el-table-column type="selection" width="55" :selectable="handleRoleSelectable"></el-table-column>
                <el-table-column prop="id" label="ID" min-width="80"></el-table-column>
                <el-table-column prop="role_name" label="名称" min-width="120"></el-table-column>
                <el-table-column prop="type" label="类型" min-width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1" style="color: orange">接口权限</span>
                        <span v-else-if="scope.row.type == 2" style="color:blue">字段权限</span>
                        <span v-else >行级权限</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" style="color: green">启用</span>
                        <span v-else style="color: red">禁用</span>
                    </template>
                </el-table-column>

            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleRoleClose">取 消</el-button>
                <el-button type="primary" @click="handleRoleSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../js/common.js';
import draggableList from '../../../common/Drawer.vue';
import crmUpload from '../../../common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'adminListComponent',
    data() {
        return {
            draggable: {
                data_name: 'admin'
            },
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            roleData: {
                visable: false,
                admin_id: 0,
                selected: [],
                data: []
            }
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['code', 'name']) && row.rid) {
                this.$router.push({
                    path: '/adminDetail',
                    query: {
                        id: row.rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                name: '',
                code: '',
                mobile: '',
                status: '',
                role_id: ''
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('admin_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('admin_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('admin', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).admin;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'adminLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'adminEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'adminDelete', row.name);
        },
        // 重置密码
        resetPassword(row) {

            this.$confirm('您确定要重置【' + row.name + '】的密码吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.$api['resetPassword']({
                        rid: row.rid
                    })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '重置成功！',
                                    type: 'success'
                                });
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'adminEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'adminEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        // 编辑详情
        handleRole(index, row) {
            this.roleData.visable = true;
            this.roleData.admin_id = row.id;
            this.$api
                .getRolesWithAdmin({
                    admin_id: row.id
                })
                .then((res) => {
                    if (res.code == 0) {
                        this.roleData.data = res.data;
                        this.roleChecked();
                    }
                })
                .catch((error) => {});
        },
        handleRoleSubmit() {
            let params = {
                roles: this.roleData.selected.map((item) => item.id),
                id: this.roleData.admin_id
            };
            this.$api
                .saveRoles(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '设置成功!'
                        });
                        this.roleData.visable = false;
                        this.getList(0);
                    }
                })
                .catch((error) => {});
        },
        roleChecked() {
            this.roleData.data.forEach((item, index) => {
                if (item.checked === true) {
                    // 等表格数据加载完成后
                    this.$nextTick(() => {
                        // 注意：toggleRowSelection(item, true) 中 item 必须是行数据
                        this.$refs.role_data_ref.toggleRowSelection(this.roleData.data[index], true);
                    });
                }
            });
        },
        handleRoleClose() {
            this.roleData.visable = false;
        },
        handleRoleChange(val) {
            this.roleData.selected = val;
        },
        handleRoleSelectable(row) {
            return row.status === 1;
        },
        reset() {
            this.initQueryParams();
            this.$refs.status_ref && this.$refs.status_ref.reset();
            this.$refs.role_id_ref && this.$refs.role_id_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>